import car1 from "./images/car1.jpeg";
import details1 from "./images/details1.jpeg";
import details2 from "./images/details2.jpeg";
import details3 from "./images/details3.jpeg";
import details4 from "./images/details4.jpeg";
import details5 from "./images/details5.jpeg";
import details6 from "./images/details6.jpeg";
import details7 from "./images/details7.jpeg";

import car2 from "./images/car2.jpeg";
import detailsCls1 from "./images/detailsCls1.jpeg";
import detailsCls2 from "./images/detailsCls (2).jpeg";
import detailsCls3 from "./images/detailsCls (3).jpeg";
import detailsCls4 from "./images/detailsCls (4).jpeg";
import detailsCls5 from "./images/detailsCls (5).jpeg";
import detailsCls6 from "./images/detailsCls (6).jpeg";
import detailsCls7 from "./images/detailsCls (7).jpeg";
import detailsCls8 from "./images/detailsCls (8).jpeg";
import detailsCls9 from "./images/detailsCls (9).jpeg";

import car3 from "./images/car3.jpeg";
import detailsGle1 from "./images/detailsGle (1).jpeg";
import detailsGle2 from "./images/detailsGle (2).jpeg";
import detailsGle3 from "./images/detailsGle (3).jpeg";
import detailsGle4 from "./images/detailsGle (4).jpeg";
import detailsGle5 from "./images/detailsGle (5).jpeg";
import detailsGle6 from "./images/detailsGle (6).jpeg";
import detailsGle7 from "./images/detailsGle (7).jpeg";
import detailsGle8 from "./images/detailsGle (8).jpeg";

import car4 from "./images/car4.jpeg";
import detailsRangeRover1 from "./images/detailsRangeRover (1).jpg";
import detailsRangeRover2 from "./images/detailsRangeRover (2).jpg";
import detailsRangeRover3 from "./images/detailsRangeRover (3).jpg";
import detailsRangeRover4 from "./images/detailsRangeRover (4).jpg";
import detailsRangeRover5 from "./images/detailsRangeRover (5).jpg";
import detailsRangeRover6 from "./images/detailsRangeRover (6).jpg";

const cars = [
  {
    sys: {
      id: "1",
    },
    fields: {
      name: " Mercedes-Benz GLC 250d 4MATIC",
      slug: "mercedes -glc",
      type: "SUV",
      price: 25000,
      km: "",
      year: 2019,
      size: 72,
      carMake: "Mercedes-Benz",
      gps: true,
      sportPackage: false,
      featured: false,
      description:
        "🚗 Shitet Mercedes-Benz GLC 250d 4MATIC – Viti 2016 🇨🇭 Importuar nga Zvicra – Gjendje perfekte! ✨ Full opsion 🔧4x4 (4MATIC) – Gati për çdo terren",
      extras: [
        "Navigator + GPS",
        "Kamera parkimi + sensor parkimi",
        "Sallon lekure",
        "Distronic (ruajtje distance automatike)",
        "Drita Bi-Xenon & LED",
        "4x4 (4MATIC) ",
      ],
      images: [
        {
          fields: {
            file: {
              url: car1,
            },
          },
        },
        {
          fields: {
            file: {
              url: details1,
            },
          },
        },
        {
          fields: {
            file: {
              url: details2,
            },
          },
        },
        {
          fields: {
            file: {
              url: details3,
            },
          },
        },
        {
          fields: {
            file: {
              url: details4,
            },
          },
        },
        {
          fields: {
            file: {
              url: details5,
            },
          },
        },
        {
          fields: {
            file: {
              url: details6,
            },
          },
        },
        {
          fields: {
            file: {
              url: details7,
            },
          },
        },
      ],
    },
  },
  {
    sys: {
      id: "2",
    },
    fields: {
      name: "Mercedes CLS 450 AMG",
      slug: "mercedes -cls",
      type: "SEDAN",
      price: "Kontakto",
      year: 2019,
      km: "11.000",
      size: 72,
      carMake: "Mercedes-Benz",
      gps: true,
      sportPackage: true,
      featured: false,
      description:
        "🚘 Mercedes CLS 450 AMG📅 Viti: 2019 | 🛢️ 3.0 Benzin Vetem 11.000Km✨ Look AMG nga fabrika — elegancë dhe agresivitet në një trup të vetëm!",
      extras: [
        "Kamera 360° & Sensorë 360°",
        "Hapse panoramike xhami për një përvojë luksoze",
        "Distronic Plus – lëviz me siguri maksimale",
        "Blind Spot Assist – gjithmonë në kontroll",
        "Asistencë korsie ",
        "Sedilje me memorie + ngrohje + ftohje ",
        "Sistemi audio Burmester – muzika si në studio",
      ],
      images: [
        {
          fields: {
            file: {
              url: car2,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls1,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls2,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls3,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls4,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls5,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls6,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls7,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls8,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsCls9,
            },
          },
        },
      ],
    },
  },
  {
    sys: {
      id: "3",
    },
    fields: {
      name: "Mercedes GLE 350d 4MATIC - AMG Look",
      slug: "mercedes -gle",
      type: "SUV",
      price: "Kontakto",
      km: "130.000",
      year: 2020,
      size: 72,
      carMake: "Mercedes-Benz",
      gps: true,
      sportPackage: false,
      featured: false,
      description:
        "📢 Shitet Mercedes GLE 350d 4MATIC - AMG Look 📆 Viti: 2020 ℹ️130,000Km 🖤 Ngjyrë: E zezë",
      extras: [
        "Panoram",
        "Burmester",
        "hapje mbyllje ndezje pa celes",
        "Head Up Display",
        "Dritat Full Led Inteligjente",
        "Camera 360°",
        "Disctronic + Assisstenc Korsie",
      ],
      images: [
        {
          fields: {
            file: {
              url: car3,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle1,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle2,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle3,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle4,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle5,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle6,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle7,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsGle8,
            },
          },
        },
      ],
    },
  },
  {
    sys: {
      id: "4",
    },
    fields: {
      name: "Range Rover Vogue 4.4 TDV8 – Facelift",
      slug: "range -vogue",
      type: "SUV",
      price: "Kontakto",
      km: "",
      year: 2019,
      size: 72,
      carMake: "Range-Rover",
      gps: true,
      sportPackage: true,
      featured: false,
      description:
        "🇩🇪🇩🇪Range Rover Vogue 4.4 TDV8 – 2019 Facelift Luks, fuqi dhe rehati në maksimum!🇩🇪🇩🇪 Importuar Nga Gjermania",
      extras: [
        "Panoram & Head-Up Display",
        "360° Kamera & Sedilje me memorie, ngrohje, ftohje, masazh",
        "Dyer me thithje & Hapje Mbyllje Ndezje pa çelës",
        "Klimë 3-zonëshe",
      ],
      images: [
        {
          fields: {
            file: {
              url: car4,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsRangeRover1,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsRangeRover2,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsRangeRover3,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsRangeRover4,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsRangeRover5,
            },
          },
        },
        {
          fields: {
            file: {
              url: detailsRangeRover6,
            },
          },
        },
      ],
    },
  },
];

export default cars;
